import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from 'reactstrap'
import './navbar.css'
import Login from '../login'
import { Icon } from 'react-icons-kit'
import { user } from 'react-icons-kit/fa/user'
//import { facebookSquare } from 'react-icons-kit/fa/facebookSquare'
import { ic_phone } from 'react-icons-kit/md/ic_phone'
//import mapfreLogo from '../../imgs/mapfre_logo.png'
import UsuarioObj from '../../utils/usuario'
import LoginObj from '../../utils/login'
import InfoEmpresaObj from '../../utils/empresa'
const empresa = new InfoEmpresaObj()
const usuario = new UsuarioObj()
const login = new LoginObj()

class NavBar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      user: null,
      isOpen: false,
      modalLogin: false,
      infoEmpresa: {}
    }
    this.toggle = this.toggle.bind(this)
    this.LinkClick = this.LinkClick.bind(this)
    this.Login = this.Login.bind(this)
    this.toggleModalLogin = this.toggleModalLogin.bind(this)
    this.loginSuccess = this.loginSuccess.bind(this)
    this.logOut = this.logOut.bind(this)
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  toggleModalLogin() {
    this.setState({
      modalLogin: !this.state.modalLogin
    })
  }

  LinkClick() {
    this.state.isOpen && this.toggle()
  }

  Login() {
    this.LinkClick()
    this.setState({
      modalLogin: true
    })
  }

  logOut(e) {
    const _this = this
    _this.LinkClick()
    login.logOut().then(result => {
      _this.setState({
        user: null
      })
    })
  }

  loginSuccess(user) {
    this.setState({
      user,
      modalLogin: false
    })
  }

  formatTel(txt = '') {
    if (txt.length > 1) {
      return txt.substr(1)
    }
  }

  onUserLogged() {
    if (this.state.user) {
      return (
        <UncontrolledDropdown nav inNavbar>
          <DropdownToggle className="nav-link navlink" nav caret>
            <Icon size={20} icon={user} />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-principal" right>
            <DropdownItem className="dropdown-item-principal">
              <Link className="nav-link DropdownItem-link" to={`/usuario/${this.state.user && this.state.user.uid}`}>{this.state.user.email}</Link>
            </DropdownItem>
            <DropdownItem className="dropdown-divider-principal" divider />
            <DropdownItem className="dropdown-item-principal">
              <Link className="nav-link DropdownItem-link" to={`/admin/empresa/`}>Administrar empresa</Link>
            </DropdownItem>
            <DropdownItem className="dropdown-item-principal">
              <Link onClick={this.LinkClick} className="nav-link DropdownItem-link" to={`/admin/productos/`}>Administrar productos</Link>
            </DropdownItem>
            <DropdownItem className="dropdown-item-principal">
              <Link onClick={this.LinkClick} className="nav-link DropdownItem-link" to={`/admin/categorias/`}>Administrar categorías</Link>
            </DropdownItem>
            <DropdownItem>
              <Link onClick={this.LinkClick} className="nav-link DropdownItem-link" to="/admin/analytics">Analytics</Link>
            </DropdownItem>
            <DropdownItem className="dropdown-divider-principal" divider />
            <DropdownItem onClick={this.logOut} className="dropdown-item-principal">
              <Link onClick={this.LinkClick} className="nav-link DropdownItem-link" to="/">Salir</Link>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      )
    } else {
      return (
        <NavItem>
          <NavLink className="nav-link-principal" href="#" onClick={this.toggleModalLogin}>Ingresar</NavLink>
        </NavItem>
      )
    }
  }

  componentWillMount() {
    const _this = this
    empresa.getInfoEmpresa().then(infoEmpresa => {
      _this.setState({
        infoEmpresa
      })
    })
    usuario.getUserLogged().then(user => {
      _this.setState({
        user
      })
    })
  }

  render() {
    return (
      <div>
        <Navbar className="rojo fixed-top" light expand="md">
          <Link className="navbar-brand text-uppercase navlink font-weight-bold" to="/">
            Chenloseguros
          </Link>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <Link onClick={this.LinkClick} className="nav-link navlink" to="/">Inicio</Link>
              </NavItem>
              <NavItem>
                <Link onClick={this.LinkClick} className="nav-link navlink" to="/productos/">Productos</Link>
              </NavItem>
              <NavItem>
                <Link onClick={this.LinkClick} className="nav-link navlink" to="/contacto/">Contáctanos</Link>
              </NavItem>
              {
                !this.state.isOpen &&
                <NavItem>
                  <NavLink className="navlink">
                    |
                </NavLink>
                </NavItem>
              }

              <a className="nav-link navlink" href={`tel:+598${this.formatTel(this.state.infoEmpresa.Telefono)}`}>
                <Icon size={30} icon={ic_phone} />
                <span>{this.state.infoEmpresa.Telefono}</span>
              </a>
              {
                !this.state.isOpen &&
                <NavItem>
                  <NavLink className="navlink">
                    |
                </NavLink>
                </NavItem>
              }
              {
                this.state.user ?
                  this.onUserLogged()
                  :
                  <NavItem>
                    <NavLink onClick={this.Login} className="navlink" href="#">
                      Ingresar
                    </NavLink>
                  </NavItem>
              }
            </Nav>
          </Collapse>
        </Navbar>
        <Login modalLogin={this.state.modalLogin} toggleModalLogin={this.toggleModalLogin} loginSuccess={this.loginSuccess} />
      </div>
    );
  }
}

export default NavBar;